// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container__Alp9r","container1":"quote_container1__1gi6g","text":"quote_text__2j2kZ"};